import React, { useState } from "react"
import { FormattedMessage } from "react-intl"
import ReceivePaymentModal from "../../../../invoice/receivepaymentmodal.component.jsx"
import CustomerAccount from "../../../../state/customer-account/models/CustomerAccount.js"
import EventBus from "../../../EventBus.js"
import Icon from "../../../icon/icon.component.jsx"


interface OwnProps {
    contactId: string
    customerAccount : CustomerAccount
}

const InvoiceReceivePaymentButton = (props: OwnProps) => {
    const [openModal, setOpenModal] = useState<boolean>(false)

    const handleOpenModal = () => {
        setOpenModal(true)
    }

    const handleCloseModal = (paymentType? : string) => {
        setOpenModal(false)
        EventBus.dispatch(EventBus.TopicRefreshCustomerDetails, {
            contactId: props.contactId
        })
        EventBus.dispatch(EventBus.TopicCustomerBalanceUpdate, {})
        if(paymentType) {
            window.location.reload()
        }
    }

    return (
        <>
            {openModal && <ReceivePaymentModal
                onClose={handleCloseModal}
                customerAccount={props.customerAccount.getDto()}
                customerName={props.customerAccount}
                contactId={props.contactId}
                customerAccountId={props.contactId}
            />}
            <button onClick={handleOpenModal} className="btn btn-success">
                <Icon value={"plus-circle"} />
                <FormattedMessage
                    id="customers.invoices.list.receive_payment_btn"
                    defaultMessage="Receive payments"
                />
            </button>
        </>
    )
}

export default InvoiceReceivePaymentButton


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/creation-buttons/InvoiceReceivePaymentButton.tsx